module.exports = __webpack_public_path__ + "img/bulb-green.ccc71392.png";